/**
 * Returns a Canadian dollar-formatted string with 0 or 2 decimal places; if numDecimals is not specified the
 * number of decimal places shown will be automatically chosen, and will omit the cents part for integer amounts
 * @param {number} dollars dollar amount
 * @param intl
 * @param {number} [numDecimals]
 * @return {string} intl-formatted dollar amount
 */
function formatDollars(dollars, intl, numDecimals) {
    return intl.formatNumber(dollars, {
        style: 'currency',
        currency: 'CAD',
        ...dollarDecimals(dollars, numDecimals),
    });
}

/**
 * Returns an formatNumber style object fragment that formats a dollar value with 0 or 2 decimal places
 *  - if dollars is an integer value -> do not show any cents, e.g. $8,750
 *  - if dollars is non-integer -> show exactly two decimal points, e.g. $8749.90
 *  - however, if numDecimals is a number -> use that, e.g. $12.07
 *
 * @param {number} dollars dollar amount
 * @param {number} [numDecimals]
 * @return {{maximumFractionDigits: number, minimumFractionDigits: number}}
 */
function dollarDecimals(dollars, numDecimals) {
    const decimals = typeof(numDecimals) === 'number'
        ? numDecimals
        : dollars === Math.trunc(dollars) ? 0 : 2;

    return {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    };
}


export default formatDollars;
